<template>
  <div>
    <div v-if="!selectedUser" class="sub-form">
      <div class="ttl-job">Search Company</div>
      <div class="ttl-inp">
        <v-autocomplete
          outline
          solo
          clearable
          hide-no-data
          append-icon="search"
          label="search"
          :search-input.sync="query"
          :items="company_items"
          item-text="company_name"
          return-object
          @change="populateUsers"
        >
        </v-autocomplete>
      </div>
      <div style="padding-bottom: 4rem" v-if="company_test.length > 0" >
        <div class="ttl-job">Selected Featured Companies</div>
        <div
          class="user-synops"
          v-for="company in company_test"
          :key="company.company_id"
        >
          <div class="ttl nm">{{ company.company_name }}</div>
          <div class="ttl em">{{ company.phone }}</div>
          <!-- <div class="a" :key="changekey"> -->
            <button class="btn-remove" style="margin-top: 1rem !important;" @click="removeSelection(company)" >Remove</button>
          <!-- </div> -->
        </div>
        <button class="btn btn-next-outline" @click="putFeaturedCompanies()">
          Add Featured Company(s)
        </button>
      </div>
    </div>
    <!-- Existing featured companies start -->
    <div v-if="featuredCompanies.length > 0" class="fifth-section">
      <h2 align="middle">Current Featured Companies</h2>
      <div class="row container-fluid horizontal-center" :key="changekey">
        <div v-for="company in featuredCompanies" :key="company.company_id">
          <div
            @click="goToCompanyDetailsPage(company.company_id)"
            class="row f-image-wrapper"
          >
            <!-- <p>{{company.company_name}}</p> -->
            <img
              v-if="company.image_url"
              class="f-image"
              :src="company.image_url"
            />
            <img v-else class="f-image" src="../../assets/newDesign/exp.svg" />
          </div>
        </div>
      </div>
    </div>
    <!-- Existing featured companies end -->

    <v-snackbar :color="bgColor" :timeout="timeOut" top v-model="snackbar">
      <div style="text-align: center; width: 100%; color: black">
        <span style="padding-right:1.0rem"
          ><v-icon color="black">{{ snackIcon }}</v-icon></span
        >{{ snackMessage }}
      </div>
    </v-snackbar>
  </div>
</template>

<script>
import {
  GET_FEATURED_COMPANIES,
  ADMIN_SELECT_FEATURED_COMPANY,
  AUTO_SUGGEST_COMPANY_COMPLIANCE,
} from "../../Api/admin_api";
export default {
  name: "manage-feature-company",
  //   components: {
  //     JobForm,
  //     Confirmation
  //   },
  data: function () {
    return {
      from: "admin",
      user: {},
      company: {},
      query: "",
      featuredCompanies: [],
      company_items: [],
      company_users: [],
      company_test: [],
      selectedUser: false,
      confirmPost: false,
      confirmCheck: 0,
      job: {},
      propsConfirm: {
        open: false,
      },
      bgColor: "#454545",
      timeOut: 1000,
      snackbar: false,
      snackIcon: "",
      snackMessage: "",
      ripple: false,
      changekey: 0
    };
  },
  methods: {
    getCompany(v) {
      const self = this;
      AUTO_SUGGEST_COMPANY_COMPLIANCE(v)
        .then(function (data) {
          self.company_items = data;
        })
        .catch(function (data) {});
    },
    populateUsers(e) {
      const self = this;
      let temp = [];
      if (!!e) {
        temp = self.company_test.filter(
          (val) => val.company_id === e.company_id
        );
        if (temp.length === 0) self.company_test.push(e);
      }
    },
    putFeaturedCompanies() {
      const self = this;
      if (self.company_test.length > 25){
        self.snackbar = true;
        self.snackIcon = self.$constants.SNACKBAR_ICON.ERROR;
        self.bgColor = self.$constants.SNACKBAR_COLOR.ERROR;
        self.snackMessage = "Maximum 25 featured companies allowed";
        return;
      }
      ADMIN_SELECT_FEATURED_COMPANY(this.company_test)
        .then(function () {
          self.getFeaturedCompanies();
          self.company_test = [];
        })
        .catch(function (err) {});
    },
    getFeaturedCompanies() {
      const self = this;
      GET_FEATURED_COMPANIES()
        .then(function (data) {
          self.featuredCompanies = data.companies;
          self.changekey++;
        })
        .catch(function (err) {});
    },
    goToCompanyDetailsPage(id) {
      this.$router
        .push({ name: "publicCompany", query: { id: id } })
        .catch(function () {});
    },
    removeSelection(company){
      const self=this;
      self.changekey++;
      self.company_test = self.company_test.filter(comp => comp.company_id!==company.company_id);
    }
  },
  watch: {
    query(val) {
      if (val === null) {
        // this.resetAll();
      }
      val && this.getCompany(val);
    },
  },
  mounted() {
    this.getFeaturedCompanies();
  },
};
</script>

<style scoped>
.sub-form {
  max-width: 80rem;
  margin: auto;
}
.ttl-job {
  text-align: left;
  font-size: 1.6rem;
  color: #050505;
}
.ttl-inp {
  text-align: left;
  padding: 0.5rem 0;
}
.user-synops {
  background-color: #ffffff;
  text-align: left;
  padding: 2rem;
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.16);
  margin: 1rem 0;
}
.user-selected {
  text-align: left;
  max-width: 80rem;
  padding: 2rem;
  border: 1px solid #e6e6e6;
}
.ttl {
  font-size: 1.6rem;
}
.nm {
  font-size: 2rem;
  font-weight: bold;
  color: #050505;
}
.em {
  color: #3d4249;
}
.rl {
  font-size: 1.4rem;
  background-color: #0766ff;
  color: #ffffff;
  padding: 0 1rem;
  border-radius: 0.4rem;
}
.ag {
  background-color: #ff6e38;
}
.ad {
  background-color: var(--success);
}
.f-image-wrapper {
  width: 15rem;
  height: 15rem;
  padding: 1rem;
  background-color: white;
  border: 1px solid #e6e6e6;
  margin: 1rem !important;
  cursor: pointer;
}
.f-image {
  width: 100%;
  margin: auto !important;
}

</style>
